import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=22cfefc3&scoped=true&"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNavigation.vue?vue&type=style&index=0&id=22cfefc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cfefc3",
  null
  
)

export default component.exports